import { render, staticRenderFns } from "./ResalePenaltyStaleWarning.vue?vue&type=template&id=1e3fc1b4&"
import script from "./ResalePenaltyStaleWarning.vue?vue&type=script&lang=js&"
export * from "./ResalePenaltyStaleWarning.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports